module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "sad-cloudy-car.4baccb57.png" + "?" + Date.now();